import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import OrganizationForm from './components/organization-form';
import { getList as _getList, batchDeleteItem, switchEnable } from '@/api/setting/organization';
export default {
  name: 'setting-organization',
  computed: {
    isAuth: function isAuth() {
      return this.$auth();
    },
    searchItems: function searchItems() {
      if (Array.isArray(this.columns)) {
        return this.columns.map(function (item) {
          return _objectSpread(_objectSpread({
            inputType: 'text'
          }, item), {}, {
            label: item.title,
            value: item.key
          });
        });
      }
      return [];
    }
  },
  data: function data() {
    return {
      currentTableData: [],
      loading: false,
      template: null,
      pageSize: 20,
      currentPage: 1,
      total: 0,
      items: [],
      fullscreenLoading: false,
      columns: [],
      combineSearch: '',
      searchKey: ''
    };
  },
  methods: {
    getFilterCode: function getFilterCode(code) {
      this.combineSearch = code;
      this.getList();
    },
    del: function del() {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    switchHandle: function switchHandle(row, key) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var text, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              text = row[key] ? '确定启用?' : '确定禁用?';
              _context2.n = 1;
              return _this.$awaitTo(_this.$$confirm(text));
            case 1:
              _yield$_this$$awaitTo = _context2.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              if (!err) {
                _context2.n = 2;
                break;
              }
              row[key] = !row[key];
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return switchEnable({
                'l01Id': row.l01Id,
                enable: row[key]
              });
            case 3:
              _this.$message.success('操作成功');
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteItems: function deleteItems() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var stuctCodes;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this2.$$confirm('确定删除?');
            case 1:
              stuctCodes = _this2.items.map(function (item) {
                return item.l01StrucCode;
              });
              _context3.n = 2;
              return batchDeleteItem({
                codes: stuctCodes.join(',')
              });
            case 2:
              _this2.$message.success('操作成功');
              _this2.items = [];
              _this2.$refs.multipleTable.clearSelection();
              _this2.getList();
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(items) {
      this.items = items;
    },
    create: function create(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$awaitTo(_this3.$dialog(OrganizationForm, {
                dialog: {
                  title: '架构详情',
                  width: '800px'
                },
                props: {
                  id: item ? item.l01StrucCode : undefined,
                  total: _this3.total,
                  onlyReady: !_this3.isAuth
                }
              }, function (template) {
                _this3.template = template;
              }));
            case 1:
              _yield$_this3$$awaitT = _context4.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 1);
              err = _yield$_this3$$awaitT2[0];
              _this3.template = null;
              if (!err) {
                _this3.getList();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      if (this.loading) {
        return;
      }
      this.currentPage = page;
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_getList, data, datas, total, columns;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.loading = true;
              _context5.n = 1;
              return _getList({
                simpleSearch: _this4.searchKey,
                combineSearch: _this4.combineSearch,
                length: _this4.pageSize,
                page: _this4.currentPage
              });
            case 1:
              _yield$_getList = _context5.v;
              data = _yield$_getList.data;
              datas = data.datas, total = data.total, columns = data.columns;
              if (Array.isArray(datas)) {
                _this4.currentTableData = datas.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    isEffect: item.l01IsEffect === 'Y'
                  });
                });
              } else {
                _this4.currentTableData = [];
              }
              _this4.total = total;
              _this4.loading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};